import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import {extend, override} from 'flarum/common/extend';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import PageContent from './pageContent';

app.initializers.add('morphdev/mfad-theme', () => {
  app.routes['mfad-theme.error'] = { path: '/error-message', component: PageContent };
});

extend(HeaderPrimary.prototype, 'items', function(items) {
  items.add(
    'title',
    <div class="header-title">
      <a href='/'>
        <h2 class='title-items' style="color: white">THE CLUBHOUSE</h2>
      </a>
    </div>,
    5
  );
});

extend(DiscussionHero.prototype, 'items', function(items){
  var tags = document.querySelectorAll('.TagLabel.colored');
  tags.forEach(tag => {
    tag.classList.remove('colored');
    tag.style.color = 'white';
  })
})


override(WelcomeHero.prototype, 'view', function(items) {
  const newContent = (
    <div class="welcome-logo">
      <img src={app.forum.attribute('baseUrl') + '/assets/' + app.forum.attribute('landing.logo_path')} />
    </div>
  )
  var content = items()
  content.children.unshift(newContent)
  if(content.attrs.className !== undefined){
    return content
  }
})

